import { useEffect, useState } from 'react'
import { getAtributosUsuario } from '@/common/utils/services/usuarios.service'
import { getContrato, getIdUsuario } from '@/auth/auth.utils'
import { useAuthStore } from '@/common/zustand/store/auth.store'
import { esUsuarioAdminARToHyS } from '@/common/utils/perfil/atributos'

const ID_SISTEMA_WEB = 1

/**
 * Resuelve si la pantalla de selección de cuenta tiene que mostrar el buscador
 * de Admin ART/HyS (PBI #80676) o la grilla de cuentas asociadas (PBI #80498).
 *
 * Ante cualquier error se asume que no es Admin ART/HyS: la grilla sólo expone
 * las cuentas propias del usuario, y el backend igual valida el permiso al
 * cambiar de contrato.
 *
 * @returns {{ esAdminARToHyS: boolean, isLoading: boolean }}
 */
export const useRolSeleccionCuenta = () => {
  const contratoStore = useAuthStore((s) => s.contrato)
  const contrato = contratoStore ?? getContrato()

  const [esAdminARToHyS, setEsAdminARToHyS] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelado = false

    const resolverRol = async () => {
      const idUsuario = getIdUsuario()

      if (!idUsuario) {
        setEsAdminARToHyS(false)
        setIsLoading(false)
        return
      }

      // No se vuelve a isLoading=true si cambia el contrato: la vista ya
      // pintada se conserva mientras se revalida, sin parpadear al skeleton.
      const resultado = await getAtributosUsuario(Number(idUsuario), ID_SISTEMA_WEB, contrato ? Number(contrato) : null)

      if (cancelado) return

      setEsAdminARToHyS(resultado.code === 200 && esUsuarioAdminARToHyS(resultado.data))
      setIsLoading(false)
    }

    resolverRol()

    return () => {
      cancelado = true
    }
  }, [contrato])

  return { esAdminARToHyS, isLoading }
}
